<template>
  <div class="Industrial">
    <!-- <div class="industrial__title w margin">
      <h4>{{ title }}</h4>
      <p>{{ text }}</p>
    </div> -->

    <div v-if="homeData" class="Industrial__box w margin">
      <a
        :href="homeData.banners.top_right.link"
        target="_blank"
        class="Industrial__item item1 box1"
      >
        <div class="hover"></div>
        <div class="texts">
          <p>{{ homeData.banners.top_right.title }}</p>
          <!-- <span> ۲۳۵.۰۰۰ متر مربع</span> -->
        </div>
        <img
          :src="homeData.banners.top_right.image"
          :alt="homeData.banners.top_right.title"
        />
      </a>
      <a
        :href="homeData.banners.top_left.link"
        target="_blank"
        class="Industrial__item item2 box2"
      >
        <div class="hover"></div>
        <div class="texts">
          <p>{{ homeData.banners.top_left.title }}</p>
        </div>
        <img
          :src="homeData.banners.top_left.image"
          :alt="homeData.banners.top_left.title"
        />
      </a>
      <a
        :href="homeData.banners.bottom_one.link"
        target="_blank"
        class="Industrial__item item3 box3"
      >
        <div class="hover"></div>
        <div class="texts">
          <p>{{ homeData.banners.bottom_one.title }}</p>
        </div>
        <img
          :src="homeData.banners.bottom_one.image"
          :alt="homeData.banners.bottom_one.title"
        />
      </a>
      <a
        :href="homeData.banners.bottom_two.link"
        target="_blank"
        class="Industrial__item item4 box4"
      >
        <div class="hover"></div>
        <div class="texts">
          <p>{{ homeData.banners.bottom_two.title }}</p>
        </div>
        <img
          :src="homeData.banners.bottom_two.image"
          :alt="homeData.banners.bottom_two.title"
        />
      </a>
      <a
        :href="homeData.banners.bottom_three.link"
        target="_blank"
        class="Industrial__item item5 box5"
      >
        <div class="hover"></div>
        <div class="texts">
          <p>{{ homeData.banners.bottom_three.title }}</p>
        </div>
        <img
          :src="homeData.banners.bottom_three.image"
          :alt="homeData.banners.bottom_three.title"
        />
      </a>
      <a
        :href="homeData.banners.bottom_four.link"
        target="_blank"
        class="Industrial__item item6 box6"
      >
        <div class="hover"></div>
        <div class="texts">
          <p>{{ homeData.banners.bottom_four.title }}</p>
        </div>
        <img
          :src="homeData.banners.bottom_four.image"
          :alt="homeData.banners.bottom_four.title"
        />
      </a>
    </div>

    <div class="Industrial__more">
      <router-link to="/industrialPark"> {{ $root.globalData.keys.show_more_text  }} </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "مناطق صنعتی ایران",
      text: " لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم ",
    };
  },
  computed: {
    homeData() {
      return this.$store.getters.getHomeData;
    },
  },
};
</script>

<style scoped>
.Industrial {
  width: 100%;
  background-color: #e3e3e3;
  box-shadow: 0 0px 30px #ccc;
  padding: 2rem 0;
}

.industrial__title {
  text-align: center;
  width: 50%;
  padding-bottom: 3rem;
}
@media only screen and (max-width: 600px) {
  .industrial__title {
    width: 70%;
  }
}

.Industrial__box {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(2, 300px);
  grid-auto-rows: 300px;
  gap: 30px;
}
.box1 {
  grid-column: 1/ 9;
}
.box2 {
  grid-column: 9/ -1;
}
.box3 {
  grid-column: 1/ 4;
}
.box4 {
  grid-column: 4/7;
}
.box5 {
  grid-column: 7/10;
}
.box6 {
  grid-column: 10/-1;
}

.industrial__title h4 {
  font-size: 28px;
}

.industrial__title p {
  margin-top: 1rem;
  font-size: 16px;
}
.Industrial__item {
  color: #fff;
  border-radius: 10px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.8);
  background-blend-mode: multiply;
  position: relative;
}

.hover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  background-blend-mode: multiply;
  z-index: 10;
}
.texts {
  text-align: right;
  position: absolute;
  bottom: 0px;
  right: 0px;
  padding: 1rem;
  z-index: 20;
}

.texts span {
  font-size: 13px;
}
.Industrial__item img {
  width: 100%;
  height: 100%;
}

.Industrial__more a {
  background-color: #0d6efd;
  color: #fff;
  padding: 1rem 2rem;
  display: block;
  border-radius: 10px;
  margin: 3rem 0 1rem 0;
  border: 2px solid #0d6efd;
  transition: all ease 0.5s;
  width: 170px;
  margin: 10px auto;
}

.Industrial__more a:hover {
  background-color: #fff;
  color: #0d6efd;
}

@media only screen and (max-width: 768px) {
  .Industrial__box {
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: 300px;
    grid-template-rows: repeat(4, 150px);
    width: 90%;
    gap: 10px;
  }

  .Industrial__item img {
    object-fit: cover;
  }

  .box1 {
    grid-column: 1 / -1;
  }
  .box2 {
    grid-column: 1/ 9;
  }
  .box3 {
    grid-column: 1/ 9;
  }
  .box4 {
    grid-column: 9 / -1;
    grid-row: 2/ 4;
  }
  .box5 {
    grid-column: 1/ -1;
  }

  .box6 {
    display: none;
  }
}
</style>
